import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, withStyles } from '@material-ui/core';
import GoDeeperPillsStyles from './GoDeeperPillsStyles';
import { GO_DEEPER_MESSAGE, GO_DEEPER_SUB_MESSAGE } from '../../constants/AgenticTextConstants';

const GoDeeperPills = ({ classes, pills }) => (
  <>
    <Box className={classes.pillsContainer}>
      <Typography variant="h5" className={classes.titleStyle}>
        <span className={classes.fontBoldStyle}>{GO_DEEPER_MESSAGE}</span> <span>{GO_DEEPER_SUB_MESSAGE}</span>
      </Typography>
      <Box className={classes.scrollContainer}>
        <Box className={classes.suggestionContainer}>
          {pills.map((item, index) => (
            <Box key={index} component="p" className={classes.suggestionButton}>
              {item?.content}
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  </>
);

GoDeeperPills.propTypes = {
  classes: PropTypes.object.isRequired,
  pills: PropTypes.array.isRequired
};

export default memo(withStyles(GoDeeperPillsStyles)(GoDeeperPills));
